import { Form, Input, Checkbox, Slider, InputNumber, Button, Radio } from 'antd';
import React from 'react';
import Notification from '../../reuseableComponents/Notification';

const LeftSection = ({ propertiesFunc }) => {
  const [form] = Form.useForm();

  const onApply = async (values) => {
    let data = { ...values };

    try {
      if (data.price && data.price.length > 0) {
        const [minPrice, maxPrice] = data.price;
        delete data.price;
        data = { ...data, minPrice, maxPrice };
      }

      if (data.minSqFt || data.maxSqFt) {
        delete data.squareFeet;
        data = {
          ...data,
          minSquare: data.minSqFt || 0,
          maxSquare: data.maxSqFt || 0
        };
      }

      if (data.minLotSize || data.maxLotSize) {
        delete data.lotSize;
        data = {
          ...data,
          minLotSize: data.minLotSize || 0,
          maxLotSize: data.maxLotSize || 0
        };
      }

      propertiesFunc(data, true);
    } catch (err) {
      Notification('error', "Error", "Error.");
    }
  };

  return (
      <Form
          form={form}
          layout="vertical"
          onFinish={onApply}
          style={{padding: 10, borderRight: "1px solid #DDDDDD"}}
      >
        {/* Categories */}
        <h4 style={{marginBottom: 10}}>Categories</h4>
        <Form.Item name="type">
          <Radio.Group style={{ display: 'flex', flexDirection: 'column', gap:10 }}>
            <Radio value={null}>All</Radio>
            <Radio value="Home">Home</Radio>
            <Radio value="Apartment">Apartment</Radio>
            <Radio value="Flat">Flat</Radio>
          </Radio.Group>
        </Form.Item>
        <h4 style={{marginBottom: 10}}>Type</h4>
        <Form.Item name="isForSale">
          <Radio.Group style={{ display: 'flex', flexDirection: 'column', gap:10 }}>
            <Radio value={null}>All</Radio>
            <Radio value={true}>Buy</Radio>
            <Radio value={false}>Rent</Radio>
          </Radio.Group>
        </Form.Item>

        {/* Recommendations */}
        {/*<h4 style={{ marginBottom: 10 }}>Recommendations</h4>*/}
        {/*<Form.Item name="recommendations" valuePropName="checked">*/}
        {/*  <Checkbox>Our Recommendations</Checkbox>*/}
        {/*</Form.Item>*/}

        {/* Saved Properties */}
        {/*<h4 style={{ marginBottom: 10 }}>Saved properties</h4>*/}
        {/*<Form.Item name="saved" valuePropName="checked">*/}
        {/*  <Checkbox>Saved</Checkbox>*/}
        {/*</Form.Item>*/}

        {/* Price Range */}
        <h4 style={{marginBottom: 10}}>Price Range</h4>
        <Form.Item label="Price Range" name="price">
          <Slider range min={0} max={2000000} defaultValue={[0, 2000000]}/>
        </Form.Item>

        {/* Completeness */}
        <h4 style={{marginBottom: 10}}>Completeness</h4>
        <div style={{display: "flex", gap: 10, width: "100%", justifyContent: "space-between"}}>
          <Form.Item style={{width: "48%"}} label="Bedrooms" name="bedRoom">
            <InputNumber style={{width: "100%"}} min={1} max={20}/>
          </Form.Item>
          <Form.Item style={{width: "48%"}} label="Bathrooms" name="bathRoom">
            <InputNumber style={{width: "100%"}} min={1} max={20}/>
          </Form.Item>
        </div>
        <Form.Item style={{width: "48%"}} label="Stairs" name="stairs">
          <InputNumber style={{width: "100%"}} min={1} max={20}/>
        </Form.Item>

        {/* Property Facts */}
        <h4 style={{marginBottom: 10}}>Property Facts</h4>
        {/*<Form.Item label="Square Feet" name="squareFeet">*/}
        {/*  <Input.Group compact style={{ display: "flex" }}>*/}
        {/*    <Form.Item name="minSqFt" noStyle>*/}
        {/*      <Input type="number" placeholder="Min" />*/}
        {/*    </Form.Item>*/}
        {/*    <Form.Item name="maxSqFt" noStyle>*/}
        {/*      <Input type="number" placeholder="Max" />*/}
        {/*    </Form.Item>*/}
        {/*  </Input.Group>*/}
        {/*</Form.Item>*/}

        <Form.Item label="Lot Size" name="lotSize">
          <Input.Group compact style={{display: "flex"}}>
            <Form.Item name="minLotSize" noStyle>
              <Input type="number" placeholder="Min"/>
            </Form.Item>
            <Form.Item name="maxLotSize" noStyle>
              <Input type="number" placeholder="Max"/>
            </Form.Item>
          </Input.Group>
        </Form.Item>

        {/* Apply Button */}
        <Form.Item className="button">
          <Button size="large" type="primary" style={{width: "100%"}} htmlType="submit">
            Apply
          </Button>
        </Form.Item>
      </Form>
  );
};

export default LeftSection;
